import React from 'react';
import {
  Box, Button, Heading, Icon, Stack, Text, VStack,
} from '@chakra-ui/react';
import router from 'next/router';

const TicketIcon = () => (
  <Icon
    viewBox="0 0 24 24"
    boxSize="52px"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    color="gray.300"
  >
    <rect x="2" y="7" width="20" height="12" rx="2" />
    <path d="M2 11a2 2 0 0 0 0 4M22 11a2 2 0 0 1 0 4M10 7v12M6 3v2M18 3v2" />
  </Icon>
);

/**
 * Shown when no events are on sale — which, with one event a year, is most of
 * the time. Previously this route rendered a hero above a blank page.
 *
 * Says what is true, then points at the thing that IS running.
 */
const EventEmptyState = () => (
  <Box
    bg="white"
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="2xl"
    boxShadow="0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
    px={[6, 12]}
    py={[10, 14]}
    maxW="520px"
    mx="auto"
    textAlign="center"
  >
    <VStack spacing={5}>
      <TicketIcon />
      <Box>
        <Heading as="h2" size="lg" mb={2}>No events on sale right now</Heading>
        <Text color="gray.600">
          Our next performance hasn&apos;t been announced yet. Our weekly classes are running as usual.
        </Text>
      </Box>
      <Stack direction={['column', 'row']} spacing={3} w={['100%', 'auto']} pt={1}>
        <Button variant="solid" colorScheme="yellow" onClick={() => router.push('/')}>
          Browse classes
        </Button>
      </Stack>
    </VStack>
  </Box>
);

export default EventEmptyState;
